import { jsx as g } from "@emotion/react/jsx-runtime";
import { css as m } from "@emotion/react";
import { ActionIcon as G, Icon as d, desktopFirstMediaQuery as e } from "@inflearn/ds-react-next";
import { as as u, ak as C } from "./StickyHeaderSkeleton-c9bad78d.mjs";
import "react";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/locale/vi";
import "dayjs/locale/ja";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/timezone";
import "dayjs/plugin/updateLocale";
import "dayjs/plugin/utc";
import "@inflearn/analytics";
import "@tanstack/react-query";
import "@inflearn/datasource-rest";
var n = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 });
  var b = "far", I = "angle-up", a = 448, l = 512, i = [8963], t = "f106", o = "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z";
  c.definition = {
    prefix: b,
    iconName: I,
    icon: [
      a,
      l,
      i,
      t,
      o
    ]
  }, c.faAngleUp = c.definition, c.prefix = b, c.iconName = I, c.width = a, c.height = l, c.ligatures = i, c.unicode = t, c.svgPathData = o, c.aliases = i;
})(n);
const Z = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};
function Y({
  isAntMan: c
}) {
  return /* @__PURE__ */ g(G, { "aria-label": "move-to-top", variant: "default", size: 42, radius: "md", tabIndex: u.MOVE_TOP, onClick: Z, mr: 16, css: X({
    isAntMan: c
  }), children: /* @__PURE__ */ g(d, { icon: n.faAngleUp, color: "dark", size: "md" }) });
}
const X = ({
  isAntMan: c
}) => /* @__PURE__ */ m({
  position: "fixed",
  zIndex: C(c).MOVE_TOP,
  bottom: "72px",
  left: "32px",
  [e.tablet]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL0Zsb2F0aW5nQnV0dG9uL01vdmVUb3AudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStCRSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9mZS1zaGFyZWQvZmUtc2hhcmVkL3BhY2thZ2VzL2FwcC1zaGVsbC9zcmMvY29tcG9uZW50cy9GbG9hdGluZ0J1dHRvbi9Nb3ZlVG9wLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEFjdGlvbkljb24sIGRlc2t0b3BGaXJzdE1lZGlhUXVlcnksIEljb24gfSBmcm9tICdAaW5mbGVhcm4vZHMtcmVhY3QtbmV4dCc7XG5pbXBvcnQgeyByZWd1bGFyIH0gZnJvbSAnQGluZmxlYXJuL2ZvbnRhd2Vzb21lLXN2Zy1jb3JlL2ltcG9ydC5tYWNybyc7XG5cbmltcG9ydCB7IGdldFpJbmRleCB9IGZyb20gJy4uLy4uL3N0eWxlcyc7XG5pbXBvcnQgeyBUQUJfSU5ERVggfSBmcm9tICcuLi9uZXh0L0hlYWRlci9jb25zdGFudHMvdGFiSW5kZXgnO1xuXG5jb25zdCBoYW5kbGVNb3ZlVG9wID0gKCkgPT4ge1xuICB3aW5kb3cuc2Nyb2xsVG8oe1xuICAgIHRvcDogMCxcbiAgICBiZWhhdmlvcjogJ3Ntb290aCcsXG4gIH0pO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gTW92ZVRvcCh7IGlzQW50TWFuIH06IHsgaXNBbnRNYW46IGJvb2xlYW4gfSkge1xuICByZXR1cm4gKFxuICAgIDxBY3Rpb25JY29uXG4gICAgICBhcmlhLWxhYmVsPVwibW92ZS10by10b3BcIlxuICAgICAgdmFyaWFudD1cImRlZmF1bHRcIlxuICAgICAgc2l6ZT17NDJ9XG4gICAgICByYWRpdXM9XCJtZFwiXG4gICAgICB0YWJJbmRleD17VEFCX0lOREVYLk1PVkVfVE9QfVxuICAgICAgb25DbGljaz17aGFuZGxlTW92ZVRvcH1cbiAgICAgIG1yPXsxNn1cbiAgICAgIGNzcz17c3R5bGVCdXR0b24oeyBpc0FudE1hbiB9KX0+XG4gICAgICA8SWNvbiBpY29uPXtyZWd1bGFyKCdhbmdsZS11cCcpfSBjb2xvcj1cImRhcmtcIiBzaXplPVwibWRcIiAvPlxuICAgIDwvQWN0aW9uSWNvbj5cbiAgKTtcbn1cblxuY29uc3Qgc3R5bGVCdXR0b24gPSAoeyBpc0FudE1hbiB9OiB7IGlzQW50TWFuOiBib29sZWFuIH0pID0+XG4gIGNzcyh7XG4gICAgcG9zaXRpb246ICdmaXhlZCcsXG4gICAgekluZGV4OiBnZXRaSW5kZXgoaXNBbnRNYW4pLk1PVkVfVE9QLFxuICAgIGJvdHRvbTogJzcycHgnLFxuICAgIGxlZnQ6ICczMnB4JyxcbiAgICBbZGVza3RvcEZpcnN0TWVkaWFRdWVyeS50YWJsZXRdOiB7XG4gICAgICBkaXNwbGF5OiAnbm9uZScsXG4gICAgfSxcbiAgfSk7XG4iXX0= */");
export {
  Y as default
};
